<template>
  <component :is="component" />
</template>

<script>
import priceCheck from '../components/priceCheck.vue'
import priceEdit from '../priceEdit.vue'
export default {
  components: {
    priceCheck,
    priceEdit
  },
  data() {
    return {
      component: 'priceCheck'
    }
  },
  created() {
    const { _role } = this.$route.query
    this.component = _role === 'check' ? 'priceCheck' : 'priceEdit'
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/price-manage/check/priceCheck.vue